<template>
    <div>
        <forward-transmission-modal :contacts="contacts"></forward-transmission-modal>
        <div id="submissionHistoryModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="submissionHistoryTitle" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="submissionHistoryTitle">Submission History</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>                        
                    </div>
                    <div class="modal-body">
                        <table class="table table-sm mb-3">
                            <thead>
                                <tr> 
                                    <th class="fit">Status</th>
                                    <th>Submitted By</th>
                                    <th>Completed</th>                              
                                    <th class="fit"></th>
                                </tr>
                            </thead>
                            <tbody class="table-font-size">
                                <template v-for="submission in submissions">
                                    <tr :key="'submission-' + submission.id">
                                        <td class="fit">
                                            <a href="javascript:void(0)" class="pr-1" @click="submission.detail_visible = !submission.detail_visible">
                                                <i :class="['fas fa-lg text-muted', submission.detail_visible ? 'fa-caret-down' : 'fa-caret-right']"></i> 
                                            </a>                                                                               
                                            <i class="fas fa-lg" :class="transmissionStatusIcon(submission.transmission_status_code)"></i>
                                        </td>                                    
                                        <td>{{ submission.initiated_by.last_name }}</td>
                                        <td>
                                            <span v-if="submission.transmission_method_id === TransmissionMethod.MAILED">{{ submission.completed_at | localizeTime('YYYY-MM-DD') }}</span>
                                            <span v-else>{{ submission.completed_at | localizeTime('YYYY-MM-DD HH:mm:ss') }}</span>
                                        </td>
                                        <td class="fit text-right">
                                            <div class="d-flex justify-content-between">                                                
                                                <div class="pr-2 flex-fill">
                                                    <a v-if="submission.archive_url" :href="submission.archive_url" target="_blank" class="btn btn-link btn-sm p-0" title="Download Submission Archive">
                                                        <i class="fas fa-file-archive fa-lg"></i>
                                                    </a>
                                                    <i v-else class="fas fa-file-archive fa-lg text-muted"></i>
                                                </div>
                                                <div class="flex-fill">
                                                    <transmit-button v-if="submission.completed_at" icon="fa-share" text="Forward" :object="submission" @click="clickForward" :emailEnabled="emailEnabled" :disabled="transmissionsDisabled"></transmit-button> 
                                                    <div v-else class="pl-2"><i class="fas fa-blank fa-fw fa-lg"></i></div>
                                                </div>
                                            </div>                                                                                                                       
                                        </td>                                
                                    </tr>                                       
                                    <template v-if="submission.detail_visible">
                                        <tr class="detail-row" :key="'submission-' + submission.id + 'recipients-header'"><td colspan="6" class="pl-1 font-weight-bold">Recipient(s):</td></tr>
                                        <tr v-for="(recipient, index) in submission.recipient_list" :key="'submission-' + submission.id + '-recipient-' + recipient.destination + '-' + index" :class="['detail-row', {'font-weight-bold': recipient.primary_destination}]">
                                            <td colspan="2" class="pr-2">
                                                <div class="d-flex pl-3">
                                                    <div><i v-if="recipient.revoked_at" class="fas fa-ban fa-sm text-danger status-icon" title="Email Link Revoked"></i></div>   
                                                    <div class="pr-1" :title="recipient.status.description">
                                                        <i :class="recipientStatusIcon(recipient.transmission_method_id, recipient.status_code)"></i>
                                                    </div>
                                                    <div v-if="recipient.name" class="pl-0 pr-2 col-sm-6 text-truncate" :title="recipient.name">{{ recipient.name }}</div>                                                        
                                                    <div v-if="recipient.transmission_method_id === TransmissionMethod.FAX">{{ recipient.destination | telephone }}</div>
                                                    <div v-else class="text-truncate" :title="recipient.destination">{{ recipient.destination }}</div>
                                                </div>                                              
                                            </td>
                                            <td>
                                                <span v-if="recipient.transmission_method_id === TransmissionMethod.MAILED">{{ recipient.completed_at | localizeTime('YYYY-MM-DD') }}</span>
                                                <span v-else>{{ recipient.completed_at | localizeTime('YYYY-MM-DD HH:mm:ss') }}</span>    
                                            </td>
                                            <td class="text-right">
                                                <div class="d-flex justify-content-end">
                                                    <div v-if="recipient.transmission_method_id === TransmissionMethod.EMAIL" class="px-2">
                                                        <a  href="javascript:void(0)" class="btn btn-link btn-sm p-0" title="Revoke Email Link" @click="revoke(recipient.id)">
                                                            <span class="fa-stack fa-xs">
                                                                <i class="fas fa-link fa-stack-1x fa-lg"></i>
                                                                <i class="fas fa-ban fa-stack-2x text-danger"></i>
                                                            </span>
                                                        </a>
                                                    </div>
                                                    <div class="pr-2">                                                                
                                                        <a v-if="recipient.confirmationUrl" :href="recipient.confirmationUrl" target="_blank" class="btn btn-link btn-sm p-0" title="View Confirmation">
                                                            <i class="fas fa-clipboard-check fa-lg"></i>
                                                        </a>
                                                        <i v-else class="fas fa-clipboard-check fa-lg text-muted"></i>
                                                    </div>
                                                    <div>
                                                        <button v-if="recipient.transmission_method_id !== TransmissionMethod.MAILED" class="btn btn-link btn-sm p-0" title="Resend" @click="resend(recipient, submission)" :disabled="transmissionsDisabled">
                                                            <i class="fas fa-redo-alt fa-lg"></i>
                                                        </button>
                                                        <i v-else class="fas fa-redo-alt fa-fw fa-lg icon-hidden"></i>
                                                    </div>                                                                                                                                                                                          
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                            </tbody>
                        </table>                    
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-secondary" data-dismiss="modal">Close</button>                    
                    </div>
                </div>
            </div>
        </div>
    </div>         
</template>

<script>
import { TransmissionStatus, TransmissionMethod, FaxStatus, EmailStatus, MailedStatus } from '../../constants.js';
import ForwardTransmissionModal from './ForwardTransmissionComponent.vue';
import TransmitButton from '../buttons/TransmitButtonComponent.vue';

export default {
    components: {
        ForwardTransmissionModal,
        TransmitButton
    },
    props: {
        emailEnabled: Boolean,
        clientId: Number
    },
    data() {
        return {

            // import constants into the template
            TransmissionStatus: TransmissionStatus,
            TransmissionMethod: TransmissionMethod,
            FaxStatus: FaxStatus,
            EmailStatus: EmailStatus,
            MailedStatus: MailedStatus,  

            documentId: null,
            submissions: [],
            contacts: [],
            transmissionsDisabled: false
        }
    },
    methods: {
        show: function (documentId) {
            
            this.documentId = documentId;
            this.submissions = [];

            axios.get('/ajax/documents/' + this.documentId + '/submissions')
                .then(response => {
                    this.transmissionsDisabled = response.data.transmissions_disabled;
                    this.submissions = response.data.submissions.map(e => {
                        this.$set(e, 'detail_visible', false); 
                        return e; 
                    });
                    this.contacts = response.data.contacts;
                    $('#submissionHistoryModal').modal('show'); 
                })
                .catch(error => {
                    // TODO: where should we show error message toastr or alert?
                });
        },
        refresh: function () {
            let self = this;

            if (self.documentId) {

                axios.get('/ajax/documents/' + self.documentId + '/submissions')
                    .then(response => {
                        self.submissions = response.data.submissions.map(e => {

                            // we want to retain detail visible state if we can
                            let submission = self.submissions.find(x => x.id === e.id);
                            let value = submission ? submission.detail_visible : false;
                            self.$set(e, 'detail_visible', value); 
                            return e; 
                        });
                        self.contacts = response.data.contacts;
                    })
                    .catch(error => {
                        // TODO: where should we show error message toastr or alert?
                    });
            }
        },
        revoke: function (id) {
            axios.get('/email/revoke/' + id)
                .then(response => {
                })
                .catch(error => {
                    // TODO: where should we show error message toastr or alert?
                });
        },
        transmissionStatusIcon: function (code) {
            let retval = 'fas fa-question-circle text-secondary';
            switch(code) {
                case TransmissionStatus.SUCCESS:
                    retval = 'fa-check-circle text-success';
                    break;
                case TransmissionStatus.WARNING:
                    retval = 'fas fa-exclamation-triangle fa-lg text-warning';
                    break;                    
                case TransmissionStatus.FAILURE:
                    retval = 'fa-exclamation-circle text-danger';
                    break;
                case TransmissionStatus.IN_PROGRESS:
                    retval = 'fa-spinner fa-spin text-secondary';
                    break;
            }
            return retval; 
        },        
        recipientStatusIcon: function (method, code) {
            
            let retval = 'fas fa-question-circle fa-sm text-secondary status-icon';
            if (method === TransmissionMethod.FAX) {
                if (code < FaxStatus.DOCUMENT_SENT) { retval = 'fas fa-spinner fa-spin fa-sm text-secondary status-icon'; }
                else if (code === FaxStatus.DOCUMENT_SENT) { retval = 'fas fa-check-circle fa-sm text-success status-icon';}
                else if (code > FaxStatus.DOCUMENT_SENT) { retval = 'fas fa-exclamation-circle fa-sm text-danger status-icon'; }
            }
            else if (method === TransmissionMethod.EMAIL) {
                if (code === EmailStatus.PREPROCESSING) { retval = 'fas fa-spinner fa-spin fa-sm text-secondary status-icon'; }
                else if (code === EmailStatus.SENT) { retval = 'fas fa-clock fa-sm text-primary status-icon'; }
                else if (code === EmailStatus.EXPIRED) { retval = 'fas fa-clock fa-sm text-danger status-icon'; }
                else if (code === EmailStatus.DOWNLOADED) { retval = 'far fa-check-circle fa-sm text-success status-icon'; }
                else if (code === EmailStatus.CONFIRMED) { retval = 'fas fa-check-circle fa-sm text-success status-icon'; }
                else if (code === EmailStatus.ERROR) { retval = 'fas fa-exclamation-circle fa-sm text-danger status-icon'; }
            }
            else if (method === TransmissionMethod.MAILED) {
                if (code === MailedStatus.MAILED) { retval = 'far fa-check-circle fa-sm text-success status-icon'; }
                else if (code === MailedStatus.RECEIVED) { retval = 'fas fa-check-circle fa-sm text-success status-icon'; }
            }

            return retval;
        },
        clickForward: function (method, submission) {
            $('#submissionHistoryModal').modal('hide');
            eventHub.$emit('show-forward-transmission', method, submission);
        },
        resend: function (recipient, submission) {
            recipient.status.value = submission.transmission_method_id === TransmissionMethod.FAX ? FaxStatus.PREPROCESSING : EmailStatus.PREPROCESSING;
            axios.post('/ajax/transmissions/' + submission.id + '/resend', {
                destination: recipient
            })
            .then(response => {
                toastr['success'](response.data.message, '', {timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true});
            })
            .catch(error => {
                let message = error.response.data.message;
                toastr['error'](message, 'Error', {timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true});
            });
        }                 
    },
    created() {
        eventHub.$on('show-submission-history', this.show);
        eventHub.$on('submission-history-visible', function () { 
            $('#submissionHistoryModal').modal('show'); 
        });

        const self = this;
        window.Echo.private('transmission-event.' + this.clientId).listen('TransmissionEvent', (e) => {
            self.refresh();
        });        
    },
    beforeDestroy() {
        eventHub.$off('show-submission-history');
        eventHub.$off('submission-history-visible');

        window.Echo.leave('transmission-event.' + this.clientId);        
    }
}
</script>

<style scoped>
    .table-font-size {
        font-size: .75rem;
    }

    th {
        border: none;
    }

    .detail-row > td {
        border: none;
        padding: 0;
    }

    .status-icon {
        position: relative;
        top: -2px;
    }

    .icon-hidden {
        color: transparent; 
    }    
</style>